<template>
  <div>
    <v-card class="pa-10 ma-16 panel" elevation="6">
      <p class="mb-10 headline text-center">エラーが発生しました</p>
      <p class="mb-0 text-center">システム内でエラーが発生しました。</p>
      <p class="mt-0 mb-0 text-center">お手数をお掛け致しますが、下のボタンから画面遷移の上</p>
      <p class="mt-0 mb-15 text-center">再度やりなおしをお願い致します。</p>
      <div class="text-center">
        <v-btn
          class="home-btn mr-15"
          rounded
          elevation="6"
          :to="$store.getters['user/homePath']"
        >ホーム画面へ</v-btn>
        <v-btn
          rounded
          elevation="6"
          @click="$router.go(-1)"
        >前の画面へ</v-btn>
      </div>
      <div class="mt-15 mx-15 pa-6 debug" v-if="isDevMode">
        <p class="mb-1" v-if="params.info">{{params.info}}</p>
        <template v-if="params.err">
          <p class="mb-1">{{params.err}}</p>
          <p class="mb-1 ml-5" v-if="params.err">isAxiosError：{{params.err.isAxiosError ? params.err.isAxiosError : false}}</p>
          <!-- API関連のエラー内容 -->
          <p class="mb-1 ml-5" v-if="params.err.config && params.err.config.method">method：{{params.err.config.method}}</p>
          <p class="mb-1 ml-5" v-if="params.err.config && params.err.config.baseURL">baseURL：{{params.err.config.baseURL}}</p>
          <p class="mb-1 ml-5" v-if="params.err.config && params.err.config.url">url：{{params.err.config.url}}</p>
          <p class="mb-1 ml-5" v-if="params.err.config && params.err.config.data">data：{{params.err.config.data}}</p>
          <!-- FRONT側ののエラー内容 -->
          <p class="mb-1 ml-5" v-if="params.err.message">message：{{params.err.message}}</p>
          <p class="mb-1 ml-5" v-if="params.err.stack">stack：{{params.err.stack}}</p>
        </template>
        <template v-else>
          <p class="mb-1">エラー内容のパラメータが見つかりません。</p>
          <p class="mb-1">プログラム修正後、再度試す場合はリロードではなく「前の画面へ」ボタンを押してください。</p>
        </template>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  computed: {
    isDevMode() {
      return process.env.NODE_ENV === 'development'
    },
    params() {
      return this.$route.params
    },
  },
}
</script>

<style lang="stylus" scoped>
.panel
  min-height 70vh

.home-btn
  background-image linear-gradient(to right, #5192ce, #2978b6 30%, #118ec6)
  color white
  font-weight bold

.debug
  background-color #ece9e6
  min-height 250px
  color #616161
</style>
